export default __webpack_public_path__ + "static/media/offer2.2bf1393a.jpg";